import { PermissionInfoBox } from "./components";
import { useMe } from "./hooks/useMe";
import { Router } from "./Router";

const App = () => {
  const { data, isLoading } = useMe();

  if (!isLoading && !data?.management_roles?.length) {
    return <PermissionInfoBox />;
  }

  return <Router isAppLoading={isLoading} />;
};

export default App;
